import React from "react";
import { Trans } from "app/utils";
import { Icon, PlainButton } from "@culturehq/components";

type MobileHeaderProps = {
  isSubmitting: boolean;
  onClose: () => void;
  onPrevStep: () => void;
  title: string;
};

const MobileHeader: React.FC<MobileHeaderProps> = ({
  isSubmitting,
  onClose,
  onPrevStep,
  title
}) => (
  <div className="MobileHeader">
    {!isSubmitting && (
      <PlainButton
        className="BackBtn"
        onClick={onPrevStep}
      >
        <Icon icon="chevron-left" />
      </PlainButton>
    )}
    <h4><Trans>{title}</Trans></h4>
    <PlainButton
      className="CloseBtn"
      onClick={onClose}
    >
      <Icon icon="close" />
    </PlainButton>
  </div>
);

export default MobileHeader;
